import { render, staticRenderFns } from "./material.vue?vue&type=template&id=43a5e9f2&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=43a5e9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a5e9f2",
  null
  
)

export default component.exports